import UIComponent from "../component";

export class CancelTariffBtn extends UIComponent {
    init() {
        this.includeComponents({
            cancel_modal: 'document@#cancelTariffModal'
        });

        this.on("click" , () => this.OpenCancelModal())
    }

    OpenCancelModal () {
        this.cancel_modal.show()
    }
}
